import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["suggestions"],
  _excluded2 = ["suggestions"];
import ActionSuggestion from 'automation-ui-action-features/components/suggestions/ActionSuggestion';
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
export default class ActionSuggestionGroup extends createImmutableObjectClass({
  description: '',
  shouldAppear: () => true,
  suggestions: [],
  supportUrl: null
}, {
  fromJSON: _ref => {
    let {
        suggestions
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return Object.assign({
      suggestions: new Map(suggestions.map(suggestion => [suggestion.id, new ActionSuggestion(suggestion)]))
    }, rest);
  },
  toJSON: _ref2 => {
    let {
        suggestions
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return Object.assign({
      suggestions: Array.from(suggestions.values())
    }, rest);
  }
}) {}